import { ENDPOINT_MCP_OAUTH_CONNECTIONS } from '../config'
import type { McpOauthConnectionSummary } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const listMcpOauthConnections = async (): Promise<
  Array<McpOauthConnectionSummary>
> => {
  const response = await AuthAxios.get<Array<McpOauthConnectionSummary>>(
    ENDPOINT_MCP_OAUTH_CONNECTIONS,
  )
  return response.data
}

export default listMcpOauthConnections
